export default __webpack_public_path__ + "static/media/arizonaCardinalsVideo-2x.633c5051.jpg";